<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/peninsular-header.png')" class="mb-6 page__header" />
    <div class="page__container">

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt10-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios chegam até às 10h</p>
          <p class="body-1 justify-text">
            <b>Cobertura ibérica:</b> Serviço de entrega prevista até às 10:00h do dia útil seguinte ao da sua recolha (Portugal Continental).
          </p>
          <p class="body-1 justify-text">
            <b>Disponível na oferta: </b> B2B.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt-14h-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios chegam até às 13h em Portugal e até às 14h em Espanha</p>
          <p class="body-1 justify-text">
            <b>Cobertura ibérica:</b> Serviço de entrega prevista até às 13:00h do dia útil seguinte ao da sua recolha em Portugal, e até às 14:00h desde o dia útil seguinte em Espanha.
          </p>
          <p class="body-1 justify-text">
            <b>Disponível na oferta: </b> B2B.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt24-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios chegam em 24h</p>
          <p class="body-1 justify-text">
            <b>Cobertura ibérica:</b> Serviço de entrega prevista desde o dia útil seguinte ao da sua recolha (Portugal e Espanha).
          </p>
          <p class="body-1 justify-text">
            <b>Disponível na oferta: </b> B2C e B2B.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt48-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envíos chegam em 48h</p>
          <p class="body-1 justify-text">
            <b>Cobertura ibérica:</b> Serviço de entrega prevista nas 48h seguintes ao dia útil da sua recolha (Portugal e Espanha).
          </p>
          <p class="body-1 justify-text">
            <b>Disponível na oferta: </b> B2C e B2B.
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Footer'

export default {
  name: 'PeninsularIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularIntro')
  },
}
</script>
